__turbopack_context__.v({
  "button": "mSccHa_button",
  "buttonBlock": "mSccHa_buttonBlock",
  "buttonBlockOnMobile": "mSccHa_buttonBlockOnMobile",
  "buttonBorder": "mSccHa_buttonBorder",
  "buttonDarkBlue": "mSccHa_buttonDarkBlue",
  "buttonDarkGreen": "mSccHa_buttonDarkGreen",
  "buttonDisabled": "mSccHa_buttonDisabled",
  "buttonGreen": "mSccHa_buttonGreen",
  "buttonGreen2": "mSccHa_buttonGreen2",
  "buttonIconCircle": "mSccHa_buttonIconCircle",
  "buttonLightGreen": "mSccHa_buttonLightGreen",
  "buttonLoading": "mSccHa_buttonLoading",
  "buttonPrimary": "mSccHa_buttonPrimary",
  "buttonRegular": "mSccHa_buttonRegular",
  "buttonSmall": "mSccHa_buttonSmall",
  "buttonSpruce": "mSccHa_buttonSpruce",
  "buttonTextOnly": "mSccHa_buttonTextOnly",
  "buttonTextOnlyWithArrow": "mSccHa_buttonTextOnlyWithArrow",
  "buttonTextWithUnderline": "mSccHa_buttonTextWithUnderline",
  "buttonUnderline": "mSccHa_buttonUnderline",
  "buttonWhite": "mSccHa_buttonWhite",
  "copyIcon": "mSccHa_copyIcon",
  "fullWidth": "mSccHa_fullWidth",
  "icon": "mSccHa_icon",
  "invert": "mSccHa_invert",
});
